import '../../App.css';
import { Container, Button, Navbar, Nav, NavItem, NavDropdown, MenuItem, NavLink,FormControl ,Form, FormLabel, Table} from 'react-bootstrap';
import React, { useState, Component } from 'react';
import {Sida,Rubrik,ContentWrapper,StyckeCompact} from "../ContentStyles";
import useBackend, {CallAPI, Loading} from '../../services/useBackend';
import {useParams, useNavigate} from 'react-router-dom';
import {DateTimeToLocal, MultiselectGetOptions, MultiselectGetDefaultValues, escapedNewLineToLineBreakTag, ConcatLocalDateAndTime2ISO, SplitoutLocalDateFromISO, SplitoutLocalTimeFromISO, getOptions} from '../../services/misc';
import {ModalOrderEdit} from './Orders'

function handleChange(event){
}

export default function CustomerEdit() {
    const {CustomerGUID} = useParams();
    const {loading, data, Refresh} =  useBackend('/api/admin/customers/'+CustomerGUID);
	const { loading: registerDataLoading, data: registerData } = useBackend(process.env.PUBLIC_URL + '/api/admin/Register');

	const [selectedOrderGuid, setSelectedOrderGuid]    = useState(null);
	const [modalshow,  setModalshow] = useState(false);
	const initModal = () => { return setModalshow(!modalshow) } 

    const orderClick = (event)  =>  {
        const orderguid = event.currentTarget.getAttribute("orderguid");
		setSelectedOrderGuid(orderguid);
		setModalshow(true);
    }

    async function closeAndRefresh() {
        setModalshow(false);
        Refresh();
    }    	

    if (!loading) {
        return (
            <ContentWrapper>
				<ModalOrderEdit modalshow={modalshow} onHide={closeAndRefresh} OrderGuid={selectedOrderGuid} registerData={registerData}></ModalOrderEdit>
                <Container>
                    <Sida>
						<Rubrik>Historik</Rubrik>

						<Form id="ProductForm">
							<Form.Group className="mb-3" >
								<Form.Label>Namn (<small>{data.Customer.SSN}</small>)</Form.Label>
								<Form.Control type="text" name="Name" placeholder="Namn"  defaultValue={data.Customer.Name} onChange={handleChange} disabled/>
							</Form.Group>
						</Form> 	

						<Rubrik>Köp</Rubrik>
							<Table responsive="sm">
								<thead>
									<tr><th>Ordernr.</th><th className="d-lg-block d-none">Skapad</th>
									<th>Status</th><th>Betalmetod</th><th style={{textAlign:'right'}}>TotalAmount</th><th style={{textAlign:'right'}}>TotalVat</th></tr>
								</thead>
								<tbody>
									{data.Customer.Orders.map((item) => {
										return <tr key={item.Guid} orderguid={item.Guid} onClick={orderClick}>
												<td><span style={{padding:5}} className='sub_'  title="Detaljer">{item.SerialNumber==null ? "Visa" : item.SerialNumber}</span></td>
												<td><span style={{padding:5}} className='sub_'  title="Detaljer">{DateTimeToLocal(item.Created)}</span></td>
												<td>{item.StateText}</td>
												<td>{item.PaymentMethodTx}</td>
												<td style={{textAlign:'right'}}>{item.TotalAmount}</td>
												<td style={{textAlign:'right'}}>{item.TotalVat}</td>
											  </tr>
									})}
								</tbody>
							</Table>
                    </Sida>
                </Container>
            </ContentWrapper>
        );
    } else {
        return (<Loading />);        
    }
}